import { createContext, useContext } from 'react';
import { DEFAULT_STORED_TRANSACTIONS } from './model';
export var TransactionsContext = createContext({
  transactions: DEFAULT_STORED_TRANSACTIONS,
  addTransaction: function addTransaction() {
    return undefined;
  },
  updateTransaction: function updateTransaction() {
    return undefined;
  }
});
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function useTransactionsContext() {
  return useContext(TransactionsContext);
}